import { render } from "./LoyaltyProgramView.vue?vue&type=template&id=67eb9647&scoped=true"
import script from "./LoyaltyProgramView.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgramView.vue?vue&type=script&lang=js"

import "./LoyaltyProgramView.vue?vue&type=style&index=0&id=67eb9647&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67eb9647"

export default script